module.exports = "/desktop-app/assets/img/assignTimeout.mp3?09608838d98152e6036d30584a2d05be";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/audio/assignTimeout.mp3
// module id = vDG8
// module chunks = 1